import {
  Typography,
  AppBar,
  Tab,
  Tabs,
  Box
} from "@material-ui/core";
import React, { useState } from "react";
import { RepoSelector } from "./RepoSelector";


interface TabPanelProps {
  children?: React.ReactNode;
  index: any;
  value: any;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={2}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


export function TabbedRepositorySelector (props : {
    selectedRepoInfo: {name: string, type: string};
    projectName: string;
    onChange: (repoName: {name: string, type: string}) => void
  },  
  ) {

  const [value, setValue] = useState(0);
  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };


  return (
    <div>
      <AppBar position="static">
        <Tabs value={"value"} onChange={handleTabChange} aria-label="repo selection">
          <Tab label="Github" {...a11yProps(0)} />
          <Tab label="Gitlab" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <TabPanel value={value} index={0} >
        <RepoSelector
          codeHostingName={"github"}
          selectedRepoName={props.selectedRepoInfo.name}
          projectName={props.projectName}
          showHint={true}
          onChange={(val) => props.onChange(val)}
        />
      </TabPanel>
      <TabPanel value={value} index={1} >
        <RepoSelector
          codeHostingName={"gitlab"}
          selectedRepoName={props.selectedRepoInfo.name}
          projectName={props.projectName}
          showHint={true}
          onChange={(val) => props.onChange(val)}
        />
      </TabPanel>
    </div>
  )

}
